import Navigation from "./Navigation"
const Loading = () => {
    return (
        <div className="text-center">
            <Navigation />
            <p className="loading-text">Loading...</p>
        </div>
    )
}

export default Loading;